import type { DesignImage } from '@/types/blocks'
import type { ContentLang } from '@/features/editor/editorSlice'
import { setLocalizedField } from '@/features/editor/lib/localizedField'
import { useOpenBlockUploadTarget } from '@/features/editor/components/shared/useOpenBlockUploadTarget'

/**
 * Цель фоновой догрузки (п.24) картинки элемента составного блока — общая для
 * панели (`ImageSettings`) и холста (`ImageElement`), чтобы оба места грузили
 * одним путём. Нужна, только если автор уйдёт, не дождавшись загрузки. Элемент
 * ищется по id в СВЕЖЕМ серверном блоке; не нашёлся (добавлен и не сохранён) или
 * id пуст — места нет, и очередь скажет об этом вместо `PUT` неизменённого тела.
 * `placeId` — id элемента: без него «то же место» было бы неотличимо от соседней
 * картинки того же блока.
 */
export const useDesignImageTarget = (element: DesignImage, contentLang: ContentLang) =>
  useOpenBlockUploadTarget((fresh, url) => {
    if (fresh.type !== 'design' || element.id.trim() === '') return null
    const target = fresh.elements.find((el) => el.id === element.id && el.type === 'image')
    if (!target) return null
    return {
      ...fresh,
      elements: fresh.elements.map((el) =>
        el === target ? { ...el, ...setLocalizedField('imageUrl', contentLang, url) } : el,
      ),
    }
  }, element.id)
